var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0H93C101.284 0 108 6.71573 108 15V93C108 101.284 101.284 108 93 108H15C6.71573 108 0 101.284 0 93V15Z",
    fill: "url(#paint0_linear_3245_5398)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5015 61.75C57.5015 59.2647 59.5162 57.25 62.0015 57.25H84.2515C86.7367 57.25 88.7515 59.2647 88.7515 61.75V84C88.7515 86.4853 86.7367 88.5 84.2515 88.5H62.0015C59.5162 88.5 57.5015 86.4853 57.5015 84V61.75Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7505 61.75C19.7505 59.2647 21.7652 57.25 24.2505 57.25H46.5005C48.9858 57.25 51.0005 59.2647 51.0005 61.75V84C51.0005 86.4853 48.9858 88.5 46.5005 88.5H24.2505C21.7652 88.5 19.7505 86.4853 19.7505 84V61.75Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5015 23.999C57.5015 21.5137 59.5162 19.499 62.0015 19.499H84.2515C86.7367 19.499 88.7515 21.5137 88.7515 23.999V46.249C88.7515 48.7343 86.7367 50.749 84.2515 50.749H62.0015C59.5162 50.749 57.5015 48.7343 57.5015 46.249V23.999Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7505 23.999C19.7505 21.5137 21.7652 19.499 24.2505 19.499H46.5005C48.9858 19.499 51.0005 21.5137 51.0005 23.999V46.249C51.0005 48.7343 48.9858 50.749 46.5005 50.749H24.2505C21.7652 50.749 19.7505 48.7343 19.7505 46.249V23.999Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2262 46.1226C72.3103 46.1226 73.9998 47.8139 73.9998 49.9003V76.3448C73.9998 78.4312 72.3103 80.1226 70.2262 80.1226H37.7733C35.6892 80.1226 33.9998 78.4312 33.9998 76.3448V49.9003C33.9998 47.8139 35.6892 46.1226 37.7733 46.1226H70.2262ZM53.8111 54.8114C51.4144 54.8114 49.4715 56.7565 49.4715 59.1559C49.4715 60.8171 50.4029 62.26 51.7714 62.9909C52.0775 63.1543 52.2832 63.4753 52.2449 63.8206L51.4515 70.9725C51.4018 71.4201 51.7516 71.8114 52.2014 71.8114H55.4207C55.8705 71.8114 56.2203 71.42 56.1707 70.9725L55.3769 63.8206C55.3386 63.4753 55.5443 63.1543 55.8504 62.9909C57.219 62.2601 58.1507 60.8172 58.1507 59.1559C58.1507 56.7565 56.2078 54.8114 53.8111 54.8114Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4998 28.1226C60.9556 28.1226 66.9998 34.1116 66.9998 41.4994V51.4849C66.9998 52.9416 65.808 54.1226 64.3378 54.1226C62.8676 54.1226 61.6758 52.9416 61.6758 51.4849V41.4994C61.6758 37.0251 58.0153 33.3979 53.4998 33.3979C48.9842 33.3979 45.3237 37.0251 45.3237 41.4994V51.4849C45.3237 52.9416 44.1319 54.1226 42.6617 54.1226C41.1916 54.1226 39.9998 52.9416 39.9998 51.4849V41.4994C39.9998 34.1116 46.0439 28.1226 53.4998 28.1226Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3245_5398",
    x1: 0,
    y1: 0,
    x2: 108,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002EBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLocked);
export default __webpack_public_path__ + "static/media/loading-locked.38b94197b984f16121c8dbb237c72a8b.svg";
export { ForwardRef as ReactComponent };